import { useCurrentCast } from '@/modules/casts/compositions'
import { ComputedRef, computed } from '@vue/composition-api'

const useCurrentScene = (sceneId: ComputedRef<string|null>) => {
  const { currentCast } = useCurrentCast()
  const isPreviewScene = computed(() => {
    return sceneId.value !== null && currentCast.value?.previewSceneId === sceneId.value
  })
  const isProgramScene = computed(() => {
    return sceneId.value !== null && currentCast.value?.programSceneId === sceneId.value
  })

  return {
    isPreviewScene,
    isProgramScene
  }
}

export default useCurrentScene
